/**
 * Cross-sells carousel, quick-view, and add-to-cart.
 * Loaded from snippets/quick-view-modal.liquid as type="module".
 */

const SELECTOR = '[data-cross-sells]'
const SLIDES_PER_VIEW = 1.15
const SPACE_BETWEEN = 8
const CART_ADD = `${window.theme?.routes?.cart?.add || '/cart/add'}.js`

function addItem(id) {
  return fetch(CART_ADD, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
  })
    .then((r) => r.json())
    .then((res) => {
      if (res.status == '422') throw { code: 422, message: res.description }
      return res
    })
}

function initCarousel(node) {
  if (node.dataset.crossSellsInit || !node.querySelector('[data-cross-sells-slider]')) return
  node.dataset.crossSellsInit = 'true'

  const viewport = node.classList.contains('swiper') ? node : node.querySelector('.swiper')
  if (!viewport) return

  const track = viewport.querySelector('.swiper-wrapper') || viewport
  track.classList.add('flex', 'snap-x', 'snap-mandatory', 'overflow-x-auto', 'scroll-smooth')
  viewport.classList.add('overflow-hidden')

  const percent = 100 / SLIDES_PER_VIEW
  for (const slide of track.children) {
    slide.classList.add('snap-start', 'shrink-0')
    slide.style.width = `${percent}%`
  }
  track.style.gap = `${SPACE_BETWEEN}px`
}

function initAll(root = document) {
  root.querySelectorAll(SELECTOR).forEach(initCarousel)
}

function onClick(event) {
  const root = event.target.closest(SELECTOR)
  if (!root) return

  const quickView = event.target.closest('[data-quick-view-trigger]')
  if (quickView) {
    const { productUrl } = quickView.dataset
    if (productUrl) document.dispatchEvent(new CustomEvent('quick-view:open', { detail: { productUrl } }))
    return
  }

  const addButton = event.target.closest('[data-add-item-id]')
  if (addButton) {
    const { addItemId } = addButton.dataset
    if (!addItemId) return

    addButton.classList.add('loading')
    addItem(addItemId)
      .then(() => {
        addButton.classList.remove('loading')
        window.NSHybridCart?.open()
      })
      .catch((error) => {
        addButton.classList.remove('loading')
        console.error('[cross-sells] add to cart failed', error)
      })
    return
  }

  const nav = event.target.closest('[data-next], [data-prev]')
  if (!nav || !root.querySelector('[data-cross-sells-slider]')) return

  const viewport = root.classList.contains('swiper') ? root : root.querySelector('.swiper')
  const track = viewport?.querySelector('.swiper-wrapper') || viewport
  if (!track) return

  const direction = nav.hasAttribute('data-next') ? 1 : -1
  track.scrollBy({ left: viewport.clientWidth * 0.8 * direction, behavior: 'smooth' })
}

document.addEventListener('click', onClick)

initAll()

document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target)
})
